<template>
  <div class="secure account-page">
	<el-dialog title="更换头像" :visible.sync="dialogFormVisible" width="40%">
	  <div class="upload-nav">
		  <div class="upload-left">
			<el-upload
			  class="avatar-uploader"
			  action="#"
			  :auto-upload="false"
			  :show-file-list="false"
			  :on-change="changeAvatarUpload">
			  <img v-if="imageUrl" :src="imageUrl" class="avatar">
			  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
			</el-upload>
		  </div>
		  <!-- <div class="upload-right">
			<img :src="$store.state.userIcon" alt="">
			<a>头像预览</a>
		  </div> -->
	  </div>
	  <div slot="footer" class="dialog-footer">
	    <el-button @click="dialogFormVisible = false">取 消</el-button>
	    <el-button type="primary" @click="submitup">确 定</el-button>
	  </div>
	</el-dialog>
    <div class="header">
      <div class="title">安全设置</div>
    </div>
    <div class="user-info clearfix">
      <div class="icon pull-left">
        <img :src="$store.state.userIcon" alt="">
        <div class="icon-btn">
          <el-button type="text" @click="dialogFormVisible = true">更换头像</el-button>
        </div>
      </div>
      <div class="info">
        <div>
          <span>登录账号：{{ $store.state.username }}</span>
          (
          <router-link :to="{name:'Authc'}" style="color: #e74141" v-if="$store.state.userAuth==0">未实名认证，点击认证</router-link>
		  <span style="color: #02b2f8" v-else-if="$store.state.userAuth==1 || $store.state.userAuth==2 || $store.state.userAuth==5">认证中</span>
		  <span style="color: #02b2f8" v-else-if="$store.state.userAuth==3">认证失败</span>
          <span style="color: #02b2f8" v-else>已通过实名认证</span>
          )
        </div>
        <div>账号ID：{{ userInfo.userID }}</div>
        <div>注册时间：{{ userInfo.createdAt | dateFormat('YYYY年M月D日 ah:mm:ss')}}</div>
      </div>
    </div>
    <ul class="set-list">
      <li class="set-list-item clearfix">
        <div class="set-list-left pull-left">密码登录</div>
        <div class="set-list-right pull-right">
          已设置 | <a href="/verifyphone" @click="modify">修改</a>
        </div>
        <div class="set-list-mid">
          安全性高的密码可以使帐号更安全。建议您定期更换密码，设置一个包含字母，符号或数字中至少两项且长度超过6位的密码。
        </div>
      </li>
      <li class="set-list-item clearfix" v-if="this.userInfo.mail.length===0">
        <div class="set-list-left pull-left">邮箱绑定</div>
        <div class="set-list-right pull-right">
          未设置 | <a href="/verifyphone" @click="bind">绑定</a>
        </div>
        <div class="set-list-mid">
          您还未绑定邮箱，邮箱可以用于登录、找回密码。
        </div>
      </li>
	  <li class="set-list-item clearfix" v-if="this.userInfo.mail.length!==0">
	    <div class="set-list-left pull-left">邮箱绑定</div>
	    <div class="set-list-right pull-right">
	      已设置 | <a href="/verifyphone" @click="bind">修改</a>
	    </div>
	    <div class="set-list-mid">
	      您已绑定邮箱，邮箱可以用于登录、找回密码。
	    </div>
	  </li>
    </ul>
  </div>
</template>

<script>
  import moment from 'moment'
  export default {
    name: 'Secure',
    data(){
      return {
		profile: {},
		imageUrl: '',
		tximage: '',
		isJPG: false,
		isLt1M: false,
		dialogFormVisible: false,
        userInfo: {
          userID: '',
          auth: 0,
          createdAt: '',
		  mail: '',
        },
        userID: '',
        createdAt: '',
      }
    },
    methods:{
      /**
       * 获取用户信息
       */
	  modify () {
		  window.localStorage.setItem('ivActionType','password_modify')
	  },
	  bind () {
	  		  window.localStorage.setItem('ivActionType','help_email_modify')
	  },
      getUserInfo(){
        this.$api.user.getUserInfo().then(res=>{
		  console.log(res)
          if (res.code === 0) {
            this.$store.commit('setUserInfo', res.data.user_info)
            this.userInfo = {
              userID: res.data.user_info.uuid,
              auth: res.data.user_info.auth,
              createdAt: res.data.user_info.created_at,
			  mail: res.data.user_info.email
            }

            // this.userID = res.data.uuid
            // this.createdAt = res.data.created_at
          }else{
            this.$message.error(res.msg)
            console.log(res.msg)
          }
        })
      },
	  changeAvatarUpload(file){
		this.profile = file
		this.isJPG = ((file.raw.type === 'image/jpeg') || (file.raw.type === 'image/png'))
		// const isJPG = true
		this.isLt1M = file.size / 1024 / 1024 < 1
		if (!this.isJPG) {
			this.$message.error({message: '上传头像图片只能是 JPG 和 PNG 格式!', offset: 80})
		 }
		 if (!this.isLt1M) {
			this.$message.error({message: '上传头像图片大小不能超过 1MB!', offset: 120})
		}else{
			this.imageUrl = URL.createObjectURL(file.raw)
			console.log(this.imageUrl)
		}
		
	  },
	  submitup(){
		if(this.isJPG === true && this.isLt1M === true){
			console.log(this.profile.raw)
			this.$api.user.profile(this.profile.raw).then(res => {
				console.log(res)
				if (res.code === 0){
					this.$store.state.userIcon = res.data
				}
			})
			this.dialogFormVisible = false
		}
	  }
    },
    created(){
      this.getUserInfo()
    },
  }
</script>

<style>
	.avatar-uploader .el-upload {
	    border: 1px dashed #d9d9d9;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
	  }
	  .avatar-uploader .el-upload:hover {
	    border-color: #409EFF;
	  }
	  .avatar-uploader-icon {
	    font-size: 28px;
	    color: #8c939d;
	    width: 178px;
	    height: 178px;
	    line-height: 178px;
	    text-align: center;
	  }
	  .avatar {
	    width: 178px;
	    height: 178px;
	    display: block;
	  }
</style>

<style scoped>
  .user-info {
    position: relative;
    border-bottom: 1px solid #ddd;
    padding: 10px 0;
  }

  .user-info .icon {
    width: 150px;
    /*text-align: center;*/

  }

  .user-info .icon img {
    display: block;
    width: 120px;
    height: 120px;
    border-radius: 5px;
    background-color: #eaeaea;
  }

  .user-info .icon .icon-btn {
    width: 120px;
    text-align: center;
  }

  .user-info .info {
    font-size: 12px;
    padding: 20px;
  }

  .user-info .info > div {
    height: 30px;
    line-height: 30px;
  }

  .set-list-item {
    font-size: 14px;
    /*height: 80px;*/
    /*line-height: 80px;*/
    padding: 33px;
    border-bottom: 1px dashed #ddd;
  }

  .set-list-left {
    width: 140px;
    font-weight: bold;
  }
  .set-list-right{
    width: 100px;
  }
  .set-list-mid{
    overflow: hidden;
    color: #999;
  }
  .upload-nav{
	margin: 0 50px;
	display: block ruby;
  }
  .upload-right{
	  float: right;
	  right: 20%;
  }
  .upload-right img {
	  display: block;
	  width: 150px;
	}
	.upload-right a{
		margin-top: 20px;
		display: block;
		text-align: center;
	}
</style>
